module.exports = __webpack_public_path__ + "static/media/bloodstream.8c2e47ce.png";